import React, { useState } from 'react';

interface AccordionSectionProps {
  icon: string;
  title: string;
  defaultOpen?: boolean;
  badge?: 'Required' | 'Optional';
  children: React.ReactNode;
}

const AccordionSection = ({ icon, title, defaultOpen = true, badge, children }: AccordionSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const bodyId = `acc-body-${title.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <>
      <div
        className="sec-head"
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        aria-expanded={isOpen}
        aria-controls={bodyId}
      >
        <div className="sec-title">
          <span className="sec-icon">{icon}</span>
          {title}
          {badge && (
            <span className={badge === 'Required' ? 'badge-req' : 'badge-opt'}>
              {badge}
            </span>
          )}
        </div>
        <span className={`sec-chevron ${isOpen ? 'open' : ''}`}>▼</span>
      </div>
      <div className={`sec-body ${isOpen ? 'open' : ''}`} id={bodyId}>
        {children}
      </div>
    </>
  );
};

export default AccordionSection;
